import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import BackMethods from "../../back_component/BackMethods";
import {
    FaFileInvoice,
    FaEye,
    FaCalendarDay,
    FaExclamationCircle,
    FaBox
} from "react-icons/fa";

export default function ViolationPage() {

    const navigate = useNavigate();
    const { backEnd_request } = BackMethods();

    const [searchParams, setSearchParams] = useSearchParams();

    const violationTypeId = searchParams.get("violationTypeId");
    const establishment = searchParams.get("establishment");
    const reportNumber = searchParams.get("reportNumber");
    const inspector = searchParams.get("inspector");

    const page = parseInt(searchParams.get("page")) || 1;
    const size = parseInt(searchParams.get("size")) || 20;

    const [loading, setLoading] = useState(false);
    const [reports, setReports] = useState([]);
    const [totalPages, setTotalPages] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);

    const truncateWords = (text, limit) => {
        if (!text) return "---";
        const words = text.split(" ");
        if (words.length > limit) {
            return words.slice(0, limit).join(" ") + "...";
        }
        return text;
    };

    const handlePageChange = (p) => {

        if (p < 1 || p > totalPages) return;

        const params = {
            violationTypeId,
            establishment,
            reportNumber,
            inspector,
            page: p,
            size
        };

        Object.keys(params).forEach(k => !params[k] && delete params[k]);

        setSearchParams(params);

        window.scrollTo({ top: 0, behavior: "smooth" });

    };

    useEffect(() => {

        const load = async () => {

            setLoading(true);

            try {

                let data = [];

                if (establishment) {

                    data = await backEnd_request
                        .get(`/ViolationReports/by-establishment/${establishment}`)
                        .then(r => r.data);

                    setReports(data);

                }

                else if (violationTypeId) {

                    data = await backEnd_request.get(
                        `/ViolationReports/by-type`,
                        {
                            params: {
                                violationTypeId,
                                page,
                                size
                            }
                        }
                    ).then(r => r.data);

                    setReports(data.data || []);
                    setTotalRecords(data.total || 0);
                    setTotalPages(Math.ceil((data.total || 0) / size));

                }

                else if (reportNumber) {

                    data = await backEnd_request
                        .get(`/ViolationReports/by-report-number?number=${reportNumber}`)
                        .then(r => r.data);

                    setReports(data);

                }

                else if (inspector) {

                    data = await backEnd_request
                        .get(`/ViolationReports/by-inspector?inspectorName=${inspector}`)
                        .then(r => r.data);

                    setReports(data);

                }

            } catch (err) {

                console.error(err);

            } finally {

                setLoading(false);

            }

        };

        load();

    }, [searchParams]);

    return (

        <div className="bg-light min-vh-100 py-4" dir="rtl">

            <div className="container-fluid px-4">

                <div className="d-flex justify-content-between align-items-center mb-4 bg-white p-3 rounded-3 shadow-sm">

                    <div>
                        <h4 className="fw-bold text-dark m-0">
                            <FaFileInvoice className="ms-2 text-primary" />
                            سجل الضبوط المنظمة
                        </h4>

                        <small className="text-muted">
                            إجمالي السجلات: {totalRecords}
                        </small>
                    </div>

                    <button
                        onClick={() => navigate(-1)}
                        className="btn btn-dark btn-sm rounded-pill px-4 shadow-sm"
                    >
                        رجوع
                    </button>

                </div>

                {loading ? (

                    <div className="text-center py-5">
                        <div className="spinner-border text-primary"></div>
                    </div>

                ) : (

                    <div className="table-responsive custom-table-container">

                        <table className="table table-hover align-middle main-modern-table">

                            <thead>
                                <tr>
                                    <th>معلومات الضبط</th>
                                    <th>نوع المخالفة</th>
                                    <th>المخالف</th>
                                    <th>المحجوزات</th>
                                    <th>الموقع</th>
                                    <th>التاريخ والوقت</th>
                                    <th className="text-center">عرض</th>
                                </tr>
                            </thead>

                            <tbody>

                                {reports.map((r) => (

                                    <tr key={r.violationReportId} className="table-row-item">

                                        <td>
                                            <div className="fw-bold text-primary fs-6">
                                                رقم الضبط: {r.reportNumber}
                                            </div>

                                            <div className="x-small text-muted">
                                                قضية: {r.caseNumber || "---"}
                                            </div>
                                        </td>

                                        <td style={{ maxWidth: "250px" }}>
                                            <div className="d-flex align-items-start gap-2">

                                                <FaExclamationCircle className="text-warning mt-1" />

                                                <div>

                                                    <div className="fw-bold small">
                                                        {r.violationType?.name || "غير محدد"}
                                                    </div>

                                                    <div className="x-small text-muted">
                                                        {truncateWords(r.violationSummary, 10)}
                                                    </div>

                                                </div>

                                            </div>
                                        </td>

                                        <td>
                                            <div className="fw-bold small">
                                                {r.offenderName}
                                            </div>

                                            <span className="badge bg-soft-dark text-dark border fw-normal x-small">
                                                {r.offenderRole}
                                            </span>
                                        </td>

                                        <td>
                                            <div className="small">
                                                <FaBox className="ms-1 text-secondary" />
                                                {r.seizedQuantity || 0}
                                            </div>

                                            <div className="x-small text-muted">
                                                {r.depositDestination || "---"}
                                            </div>
                                        </td>

                                        <td>
                                            <div className="small fw-bold">
                                                {r.governorate}
                                            </div>

                                            <div className="x-small text-muted">
                                                {r.city} - {r.district}
                                            </div>
                                        </td>

                                        <td>
                                            <div className="small fw-bold text-dark">
                                                <FaCalendarDay className="ms-1 text-info" />
                                                {r.reportDate?.split("T")[0]}
                                            </div>

                                            <div className="x-small text-muted">
                                                {r.reportTime?.slice(0, 5)} | {r.dayName}
                                            </div>
                                        </td>

                                        <td className="text-center">

                                            <button
                                                className="action-btn view mx-auto"
                                                title="عرض التفاصيل"
                                                onClick={() =>
                                                    navigate(`/admin/violation-details?id=${r.reportNumber}`)
                                                }
                                            >
                                                <FaEye />
                                            </button>

                                        </td>

                                    </tr>

                                ))}

                            </tbody>

                        </table>

                        {reports.length === 0 && (

                            <div className="text-center py-5 bg-white rounded-3 shadow-sm mt-3 text-muted">
                                لا توجد سجلات حالياً
                            </div>

                        )}

                        {totalPages > 1 && (

                            <div className="d-flex justify-content-center mt-4">

                                <nav>

                                    <ul className="pagination pagination-sm mb-0 gap-1 flex-wrap justify-content-center">

                                        <li className={`page-item ${page === 1 ? "disabled" : ""}`}>

                                            <button
                                                className="page-link rounded-circle border-0 shadow-sm p-2"
                                                onClick={() => handlePageChange(page - 1)}
                                            >
                                                ‹
                                            </button>

                                        </li>

                                        {Array.from({ length: totalPages }, (_, i) => i + 1)
                                            .filter(p =>
                                                p === 1 ||
                                                p === totalPages ||
                                                Math.abs(p - page) <= 1
                                            )
                                            .map((p, idx, arr) => (

                                                <React.Fragment key={p}>

                                                    {idx > 0 && arr[idx - 1] !== p - 1 && (
                                                        <span className="mx-1 text-muted">...</span>
                                                    )}

                                                    <li className={`page-item ${page === p ? "active" : ""}`}>

                                                        <button
                                                            className="page-link rounded-circle border-0 shadow-sm fw-bold mx-1"
                                                            style={{ width: "38px", height: "38px" }}
                                                            onClick={() => handlePageChange(p)}
                                                        >
                                                            {p}
                                                        </button>

                                                    </li>

                                                </React.Fragment>

                                            ))}

                                        <li className={`page-item ${page === totalPages ? "disabled" : ""}`}>

                                            <button
                                                className="page-link rounded-circle border-0 shadow-sm p-2"
                                                onClick={() => handlePageChange(page + 1)}
                                            >
                                                ›
                                            </button>

                                        </li>

                                    </ul>

                                </nav>

                            </div>

                        )}

                    </div>

                )}

            </div>

            <style>{`
                .x-small { font-size: 0.72rem; }
                .bg-soft-dark { background-color: #f8f9fa; }

                .main-modern-table { border-collapse: separate; border-spacing: 0 10px; }

                .table-row-item { 
                    background-color: #fff; 
                    box-shadow: 0 3px 10px rgba(0,0,0,0.03);
                }

                .table-row-item td { padding: 15px; border: none; }

                .action-btn.view { 
                    width: 36px; 
                    height: 36px;
                    border-radius: 10px;
                    border: none;
                    background: #1a1d20;
                    color: #fff;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
            `}</style>

        </div>

    );

}